import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { getAnalysisReport } from '../../services/api';
import { RiBracesLine } from '@remixicon/react';
import { AuthContextType, useAuth } from '../../contexts/AuthContext';
import CopyToClipboard from 'react-copy-to-clipboard';

interface DisplayExportJobAnalysisProps {
    exportJobId: string;
}

const DisplayExportJobAnalysis: React.FC<DisplayExportJobAnalysisProps> = ({ exportJobId }) => {


    const [loadingExportAnalysis, setLoadingExportAnalysis] = useState<boolean>(false);
    const [analysisDialogOpen, setAnalysisDialogOpen] = useState<boolean>(false);
    const [analysisReport, setAnalysisReport] = useState<any | null>(null);
    const userAuth: AuthContextType = useAuth();

    const handleClickOpenAnalysisModal = async (export_job_id: string) => {
        setLoadingExportAnalysis(true);
        setAnalysisDialogOpen(true);
        const data = await getAnalysisReport(userAuth.authAttributes, export_job_id);
        setAnalysisReport(data);
        setLoadingExportAnalysis(false);
    }
    const handleCloseAnalysisModal = () => {
        setAnalysisDialogOpen(false);
        setAnalysisReport(null);
    };

    return (
        <>
            <IconButton onClick={() => handleClickOpenAnalysisModal(exportJobId)}>
                <RiBracesLine />
            </IconButton>


            <Dialog open={analysisDialogOpen} onClose={handleCloseAnalysisModal} maxWidth="md" fullWidth>
                <DialogTitle>Export Analysis</DialogTitle>
                <DialogContent>
                    {loadingExportAnalysis ? (
                        <DialogContent>
                            <p>Getting export details...</p>
                        </DialogContent>
                    ) : (
                        <Box>
                            <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
                                <CopyToClipboard text={JSON.stringify(analysisReport, null, 2)}>
                                    <Button variant="contained" color="primary">Copy to Clipboard</Button>
                                </CopyToClipboard>
                            </Box>
                            <Box sx={{
                                backgroundColor: '#f5f5f5',
                                padding: 2,
                                borderRadius: 2,
                                maxHeight: '400px',
                                overflowY: 'auto',
                                border: '1px solid #ddd'
                            }}>
                                <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0 }}>
                                    {JSON.stringify(analysisReport, null, 2)}
                                </pre>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAnalysisModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DisplayExportJobAnalysis;
